import { IReduxStore } from "Redux/Store/IReduxStore";

export const getSpotListCount = (state: IReduxStore) =>
    state.spotList.spotList.maxCount;